import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import cloneDeep from 'lodash.clonedeep';
import {setModalAC} from 'store/modal/modalSlice';
import {updateUserInfoACS} from 'store/profile/requestAC';

import './DeletePhoto.scss';

const DeletePhoto: React.FC = () => {
  const dispatch = useSetGlobalState();

  const profileInfo = cloneDeep(useGlobalState((state) => state.profile.profileInfo)!);

  const handleClose = () => {
    dispatch(setModalAC(null));
  };

  const onDeletePhoto = () => {
    profileInfo.profile_image = null;

    dispatch(updateUserInfoACS(profileInfo));
    dispatch(setModalAC(null));
  };

  return (
    <div className="delete-photo" data-testid="delete-photo">
      <div className="delete-photo__header">
        <div className="delete-photo__title">
          <Text tag="span">DELETE PHOTO</Text>
        </div>
        <div className="delete-photo__close" onClick={handleClose} data-testid="close-modal" role="button">
          <Icon icon="close" />
        </div>
      </div>
      <Text tag="p">Are you sure you want to delete your photo?</Text>
      <div className="delete-photo__buttons">
        <Button variant="text" onClick={handleClose}>
          Cancel
        </Button>
        <div className="delete-photo__divider" />
        <Button variant="secondary" onClick={onDeletePhoto}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeletePhoto;
